import { Store } from 'pullstate'

export const EvaluatorStore = new Store({
  evaluator: null,
  assets: null,
})
